export default {"src":"/_next/static/media/solana.253cb587.svg","height":312,"width":398,"blurWidth":0,"blurHeight":0};